var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaminhaoCinza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 51.3",
    style: {
      enableBackground: "new 0 0 62 51.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#808080;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#808080;}\r\n\t.st3{fill:none;stroke:#808080;stroke-width:2;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1991",
    transform: "translate(6.935 13.292)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.5-1.6h32c1.1,0,2,0.9,2,2v27c0,1.1-0.9,2-2,2h-32c-1.1,0-2-0.9-2-2v-27C-2.5-0.7-1.6-1.6-0.5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.7,28.6c-0.6,0-5.1,0.2-5.1-1.3V16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.1-0.6h13.4c0.6,0,1,0.4,1,1v27c0,0.6-0.4,1-1,1h-17"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_479",
    transform: "translate(41.477 22.388)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.1-1.6h9.6c1.3,0,2.4,2.4,8.4,10v9.3c0,1.3-1.1,2.4-2.4,2.4l0,0H-0.1c-1.3,0-2.4-1.1-2.4-2.4l0,0V0.8 C-2.5-0.5-1.4-1.6-0.1-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-0.1,0.4c-0.2,0-0.4,0.2-0.4,0.4v16.9c0,0.2,0.2,0.4,0.4,0.4h15.7c0.2,0,0.4-0.2,0.4-0.4V9.1 c-1.9-2.4-3.3-4.3-4.3-5.7c-1-1.3-1.9-2.6-2.4-3L-0.1,0.4 M-0.1-1.6h9.6c1.3,0,2.4,2.4,8.4,10v9.3c0,1.3-1.1,2.4-2.4,2.4H-0.1 c-1.3,0-2.4-1.1-2.4-2.4V0.8C-2.5-0.5-1.4-1.6-0.1-1.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_480",
    transform: "translate(47.499 26.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.6-1.6h5.9c0.1,0,2.8,3.6,5,6.6c0,2-1.6,3-3.6,3H0.6C-1.4,8-3,6.4-3,4.4l0,0V2C-3,0-1.3-1.6,0.6-1.6L0.6-1.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.6,0.4C-0.2,0.4-1,1.1-1,2v2.4C-1,5.3-0.2,6,0.6,6h7.2c0.6,0,1-0.1,1.3-0.3c0.1,0,0.1-0.1,0.2-0.2 c-1.4-1.9-3-4-3.8-5.1L0.6,0.4 M0.6-1.6h5.9c0.1,0,2.8,3.6,5,6.6c0,2-1.6,3-3.6,3H0.6C-1.4,8-3,6.4-3,4.4V2C-3,0-1.3-1.6,0.6-1.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_519",
    transform: "translate(11.935 38.292)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4,
    cy: 4.9,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 4,
    cy: 4.9,
    r: 5.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_520",
    transform: "translate(43.935 38.292)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10.5,4.9C8.8,8.2,5.8,11.1,4,11.4C0.5,12-2.5,8.5-2.5,4.9S0.4-1.6,4-1.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 4,
    cy: 4.9,
    r: 5.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_481",
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 14.657, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17,20c-1.4,0-4-0.1-6.8-0.5c-4.7-0.6-8-1.8-9.5-3.3c-2.2-2.2-2.6-4.6-2.6-6.3c0.1-2.1,1-4.2,2.5-5.8 s3.6-2.5,5.9-2.5s4.5,0.9,6.2,2.6c1.6,1.6,2.8,4.9,3.6,9.7C16.7,16.5,16.9,18.7,17,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,2.6c-2,0-3.9,0.8-5.2,2.2C-1.2,7.5-2,12.1,1.4,15.5c0.8,0.8,3,2.2,8.9,3c2.1,0.3,4.1,0.4,5.6,0.5 c-0.1-1.3-0.3-3-0.6-4.8c-0.8-4.5-2-7.8-3.4-9.2C10,3,7.9,2.6,6.5,2.6 M6.5,0.6c2.4,0,4.8,0.9,6.9,2.9C17.6,7.7,18.1,21,18.1,21 s0,0-0.1,0c-1.1,0-14-0.1-18-4.1c-4.2-4.2-3.4-10-0.2-13.5C1.5,1.7,3.9,0.6,6.5,0.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_521",
    transform: "translate(9.603 8.021)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 2.3,
    cy: 3.2,
    rx: 4.8,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 2.3,
    cy: 3.2,
    rx: 3.8,
    ry: 3.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaminhaoCinza);
export default __webpack_public_path__ + "static/media/Caminhao_Cinza.7471a02abaecca54df5b6be79610f42f.svg";
export { ForwardRef as ReactComponent };